import * as React from "react";
import styled, { css } from "react-emotion";
import { nest } from "d3";
import { primaryColors, zuerichBlueColors } from "../theme/colors";
import { Tag } from "../components/Tag";
import { helvetica, small } from "../theme/typefaces";
import { spacing, Space, breakpoints } from "../theme/layout";
const TagListWrapper = styled("ul") `
  list-style: none;
  padding: 0;
  margin: 0;
`;
const HorizontalTagListWrapper = styled("ul") `
  list-style: none;
  padding: 0;
  margin: 0;
  white-space: nowrap;
  ${breakpoints.large `
    white-space: normal;
  `};
`;
const TagListItem = styled("li") `
  display: inline-block;
  ${spacing.mr1};
  ${spacing.mb1};
`;
const keyOrder = {
    Topic: 0,
    Dimension: 1,
    Location: 3,
    Time: 4
};
const sortKeys = (a, b) => {
    return keyOrder[a] - keyOrder[b];
};
const byType = (tags) => nest()
    .key(d => d["@type"])
    .sortKeys(sortKeys)
    .entries(tags.sort((a, b) => {
    return b.score ? b.score["@value"] - a.score["@value"] : 0;
}));
const getTagGroupLabel = (key) => {
    switch (key) {
        case "Dimension":
            return "Dimensionen";
        case "Topic":
            return "Themen";
        case "Location":
            return "Raum";
        case "Time":
            return "Zeit";
        default:
            return key;
    }
};
export const TagList = ({ tags, getTagProps, limitPerGroup, showTitles = true }) => {
    const tagsByType = byType(tags);
    let tagIndex = 0;
    return (<div>
      {tagsByType.map(group => {
        const tags = limitPerGroup
            ? group.values.slice(0, limitPerGroup)
            : group.values;
        return (<Space key={group.key}>
            {showTitles && (<div className={css `
                  ${helvetica};
                  color: ${primaryColors.zuerichBlue};
                  ${spacing.mb1};
                `}>
                {getTagGroupLabel(group.key)}
              </div>)}
            <TagListWrapper key={group.key}>
              {tags.map(t => (<TagListItem key={t["@id"]}>
                  <Tag appearance="light" label={t.label} tagType={t["@type"]} {...(getTagProps ? getTagProps(t, tagIndex++) : {})}/>
                </TagListItem>))}
            </TagListWrapper>
          </Space>);
    })}
    </div>);
};
export const HorizontalTagList = ({ tags, getTagProps, limitPerGroup }) => {
    const tagsByType = byType(tags);
    let tagIndex = 0;
    return (<div className={css `
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        display: flex;
        ${spacing.ph2};
        ${breakpoints.large `
          overflow: visible;
          display: block;
          max-width: 90em;
          margin: 0 auto;
          ${spacing.ph0};
        `};
      `}>
      {tagsByType.map(group => {
        const tags = limitPerGroup
            ? group.values.slice(0, limitPerGroup)
            : group.values;
        return (<div key={group.key} className={css `
              display: flex;
              position: relative;
            `}>
            <div className={css `
                ${small};
                box-sizing: border-box;
                color: ${zuerichBlueColors["50"]};
                ${spacing.pr2};
                line-height: 26px;
                min-width: 200px;
                text-align: right;
                display: none;
                position: absolute;
                left: -200px;
                top: 0;
                ${breakpoints.large `
                  display: block;
                `};
              `}>
              {getTagGroupLabel(group.key)}
            </div>
            <HorizontalTagListWrapper key={group.key}>
              {tags.map(t => (<TagListItem key={t["@id"]}>
                  <Tag appearance="dark" label={t.label} tagType={t["@type"]} {...(getTagProps ? getTagProps(t, tagIndex++) : {})}/>
                </TagListItem>))}
            </HorizontalTagListWrapper>
          </div>);
    })}
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/TagList.tsx